"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTableColumnDefault = exports.getRowLabel = exports.getRowKey = exports.getAfterDefaultColumn = void 0;
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _isEmpty = require("./data/is-empty.js");
/**
  * 一些常用的工具类
  * 针对于表格使用
  *  */

/** 设置表格列头的默认参数
  * @description: 设置表格列头的默认参数
  * @param { Array } columns 列头数组
  * @return { Array } 处理后的列头数组
  */
var setTableColumnDefault = exports.setTableColumnDefault = function setTableColumnDefault(columns) {
  var strInArray = function strInArray(arr, str) {
    return Boolean(arr.find(function (string) {
      return str.indexOf(string) > -1;
    }));
  };
  var basic = function basic(str) {
    return strInArray(['create', 'update', 'auditor'], str);
  };
  var handle = function handle(column /* , i */) {
    var _column$code$toLowerC, _column$code, _column$width, _column$width2, _column$width3, _column$width4, _column$width5, _column$width6, _column$width7, _column$width8, _column$width9, _column$width0, _column$width1, _column$width10, _column$width11, _column$width12, _minWidth, _column$_minWidth, _column$align, _column$sortable, _showOverflowToolti, _column$_showOverflow;
    var columnCode = (_column$code$toLowerC = (_column$code = column.code) === null || _column$code === void 0 ? void 0 : _column$code.toLowerCase()) !== null && _column$code$toLowerC !== void 0 ? _column$code$toLowerC : '';
    // console.log('setTableColumns', columnCode)
    /* 设置列宽 */
    // •1）单据编号显示全，width: 160，按照16位编号的长度计算
    if (columnCode === 'billcode') (_column$width = column.width) !== null && _column$width !== void 0 ? _column$width : column.width = 160;
    // •2）创建人和审核人要显示用户名称，不能是登录名，创建人和审核人统一宽度为80
    else if (columnCode.includes('name') && basic(columnCode)) (_column$width2 = column.width) !== null && _column$width2 !== void 0 ? _column$width2 : column.width = 100;
    // •3）客户名称、供应商名称、经销商名称、承运商名称、组织名称等值比较长的字段的款度设置为200，width:200
    else if (strInArray(['name', 'ocpname', 'suppliername', 'carriername', 'dealername', 'deptname'], columnCode)) (_column$width3 = column.width) !== null && _column$width3 !== void 0 ? _column$width3 : column.width = 200;
    // •4）客户编码、供应商编码、承运商编码、经销商编码，width:130
    else if (strInArray(['ocpcode', 'suppliercode', 'carriercode', 'dealercode', 'deptcode'], columnCode)) (_column$width4 = column.width) !== null && _column$width4 !== void 0 ? _column$width4 : column.width = 130;
    // •5）仓库名称width=180，仓库编码90
    else if (strInArray(['warehousecode'], columnCode)) (_column$width5 = column.width) !== null && _column$width5 !== void 0 ? _column$width5 : column.width = 90;else if (strInArray(['warehousename'], columnCode)) (_column$width6 = column.width) !== null && _column$width6 !== void 0 ? _column$width6 : column.width = 180;
    // •6）状态类字段列宽：width: 80，居中对齐，比如单据状态、审核状态、过账状态，如果有字数超过4个字的，那么字数*20的宽度
    else if (strInArray(['status'], columnCode)) (_column$width7 = column.width) !== null && _column$width7 !== void 0 ? _column$width7 : column.width = 80;
    // •7）单据类型：width: 120，按照6个中文计算宽度
    else if (strInArray(['billtypename'], columnCode)) (_column$width8 = column.width) !== null && _column$width8 !== void 0 ? _column$width8 : column.width = 120;
    // •8）工厂编号width=80、工厂名称width=140
    else if (strInArray(['factorycode'], columnCode)) (_column$width9 = column.width) !== null && _column$width9 !== void 0 ? _column$width9 : column.width = 90;else if (strInArray(['factoryname'], columnCode)) (_column$width0 = column.width) !== null && _column$width0 !== void 0 ? _column$width0 : column.width = 140;
    // •9）物料编号width=130，物料名称width=200
    else if (strInArray(['materialcode', 'materielcode'], columnCode)) (_column$width1 = column.width) !== null && _column$width1 !== void 0 ? _column$width1 : column.width = 130;else if (strInArray(['materialname', 'materielname'], columnCode)) (_column$width10 = column.width) !== null && _column$width10 !== void 0 ? _column$width10 : column.width = 200;
    // •10）日期类字段列宽：width: 100, 原则是居左对齐
    else if (strInArray(['date'], columnCode) && columnCode !== 'updatetime') (_column$width11 = column.width) !== null && _column$width11 !== void 0 ? _column$width11 : column.width = 100;
    // •11）时间类字段列宽：width: 160, 原则是居左对齐
    else if (strInArray(['time'], columnCode)) (_column$width12 = column.width) !== null && _column$width12 !== void 0 ? _column$width12 : column.width = 160;
    // •12）表单行上的多选框和序号，统一width=50

    var width = column.label ? column.label.length * 20 + 20 : 50;
    (_column$_minWidth = column[_minWidth = 'min-width']) !== null && _column$_minWidth !== void 0 ? _column$_minWidth : column[_minWidth] = width !== null && width !== void 0 ? width : 50;
    (_column$align = column.align) !== null && _column$align !== void 0 ? _column$align : column.align = 'left';
    (_column$sortable = column.sortable) !== null && _column$sortable !== void 0 ? _column$sortable : column.sortable = false;
    (_column$_showOverflow = column[_showOverflowToolti = 'show-overflow-tooltip']) !== null && _column$_showOverflow !== void 0 ? _column$_showOverflow : column[_showOverflowToolti] = true;

    // 设置最小宽度
    // console.log(columns.length - 1, i, column.label)
    // if (columns.length - 1 <= i) {
    //   column['min-width'] = column.width
    //   delete column.width
    // }

    return Object.assign(column);
  };
  if (Array.isArray(columns)) {
    return columns.map(handle);
  } else if ((0, _typeof2.default)(columns) === 'object') {
    return handle(columns);
  } else return [];
};

/** 获取 默认结尾列头
  * @description: 设置表格结尾处的默认列
  * @param { Array | String } columns 列头数组
  * @return { Array } 处理后的列头数组
  */
var getAfterDefaultColumn = exports.getAfterDefaultColumn = function getAfterDefaultColumn(columns) {
  var a = '';
  var b = [];
  if (Array.isArray(columns)) a = columns.join(',');else if (typeof columns === 'string') a = columns;
  if (a.includes('create')) {
    b.push({
      label: '创建人',
      code: 'createByName'
    }, {
      label: '创建时间',
      code: 'createTime',
      sortable: true
    });
  }
  if (a.includes('update')) {
    b.push({
      label: '更新人',
      code: 'updateByName'
    }, {
      label: '更新时间',
      code: 'updateTime',
      sortable: true
    });
  }
  if (a.includes('auditor')) {
    b.push({
      label: '审核人',
      code: 'auditorByName'
    }, {
      label: '审核时间',
      code: 'auditorTime',
      sortable: true
    });
  }
  return b;
};

/** 获取 行唯一标识
  * @description: 获取 行唯一标识
  * @param { Object } row 行的数据对象
  * @param { String } appoint 指定行数据对象中哪一个字段作为key值
  * @return { String } 行唯一标识
  */
var getRowKey = exports.getRowKey = function getRowKey(row, appoint) {
  var _ref, _row$appoint;
  var a = function a() {
    return (Math.random() + '').split('.').pop();
  };
  var b = a() + new Date().valueOf();
  return (0, _isEmpty.isNoEmpty)(row) ? (_ref = (_row$appoint = row[appoint]) !== null && _row$appoint !== void 0 ? _row$appoint : row.id) !== null && _ref !== void 0 ? _ref : (0, _jsMd.default)(JSON.stringify(row) + b) : (0, _jsMd.default)(b);
};

/** 获取 行标签
  * @description: 获取 行标签
  * @param { Object } row 行的数据对象
  * @param { String } appoint 指定行数据对象中哪一个字段作为 label 值
  * @return { String } 行标签
  */
var getRowLabel = exports.getRowLabel = function getRowLabel(row, appoint) {
  var _ref2, _row$appoint2;
  return (0, _isEmpty.isNoEmpty)(row) ? (_ref2 = (_row$appoint2 = row[appoint]) !== null && _row$appoint2 !== void 0 ? _row$appoint2 : row.id) !== null && _ref2 !== void 0 ? _ref2 : '' : '';
};